import { render, staticRenderFns } from "./MoveableComponent.vue?vue&type=template&id=180cd53f&"
import script from "./MoveableComponent.vue?vue&type=script&lang=js&"
export * from "./MoveableComponent.vue?vue&type=script&lang=js&"
import style0 from "./MoveableComponent.vue?vue&type=style&index=0&id=180cd53f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports